import { render, staticRenderFns } from "./expectancy.vue?vue&type=template&id=08124ae4&scoped=true"
import script from "./expectancy.vue?vue&type=script&lang=js"
export * from "./expectancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08124ae4",
  null
  
)

export default component.exports